export type RenderingFunctions<P> = {
  mount: (props: P) => void;
  unmount: () => void;
};

export const getRenderingFunctions = <P extends Record<string, unknown>>(
  containerName: string,
): RenderingFunctions<P> => {
  switch (containerName) {
    case 'ProfilesMFE-container':
      return {
        mount: (props) => window.mountProfilesMFE<P>(containerName, props),
        unmount: () => {
          if (document.getElementById(containerName) && window.unmountProfilesMFE) {
            window.unmountProfilesMFE(containerName);
          }
        },
      };
    case 'ProfileCompletionMFE-container':
      return {
        mount: (props) => window.mountProfileCompletionMFE<P>(containerName, props),
        unmount: () => {
          if (document.getElementById(containerName) && window.unmountProfileCompletionMFE) {
            window.unmountProfileCompletionMFE(containerName);
          }
        },
      };

    case 'ProfileOnboardingMFE-container':
      return {
        mount: (props) => window.mountProfileOnboardingMFE(containerName, props),
        unmount: () => {
          if (document.getElementById(containerName) && window.unmountProfileOnboardingMFE) {
            window.unmountProfileOnboardingMFE(containerName);
          }
        },
      };

    default:
      throw new Error('no functions for that name');
  }
};
